import { SxProps } from '@mui/material'

export interface CartDrawerTypes {
  mainContentWrapper: SxProps
  contentWrapper: SxProps
  emptyWrapper: SxProps
  currencyAndLocation: SxProps
  actionButtonWrapper: SxProps
  actionPrimaryButton: SxProps
}

const CART_DRAWER_WIDTH = 381
const HEADER_HEIGHT = 68 // header padding + title + spacing
const HEADER_WITH_BUTTON_HEIGHT = 177 // header + checkout button area

export const cartDrawerStyle: CartDrawerTypes = {
  mainContentWrapper: {
    maxHeight: {
      md: `calc(100vh - ${HEADER_HEIGHT}px)`,
      lg: `calc(100vh - ${HEADER_WITH_BUTTON_HEIGHT}px)`,
    },
    pb: 5,
    overflowX: 'visible',
  },
  contentWrapper: {
    width: { md: CART_DRAWER_WIDTH },
    height: { md: '100vh' },
  },
  emptyWrapper: {
    minHeight: 100,
  },
  currencyAndLocation: {
    display: { xs: 'flex', lg: 'none' },
    flexDirection: 'column',
  },
  actionButtonWrapper: {
    p: 3,
    width: { md: CART_DRAWER_WIDTH },
    bgcolor: 'background.default',
    borderColor: 'border.primary',
    borderTopWidth: '1px',
    borderTopStyle: 'solid',
  },
  actionPrimaryButton: {
    minWidth: '100%',
  },
}
